import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n/I18nContext";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import PressKit from "./pages/PressKit";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/es" element={<Landing />} />
          <Route path="/en" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/presskit" element={<PressKit />} />
        </Routes>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
